import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `FichaVerraco`, method: 'GET', body: null, token: token})
}
